import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Container, Grid, Icon, Segment, Checkbox, Header, Accordion,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { withTranslation } from 'react-i18next';
import api from 'api';
import util from 'utils/utils';
import constants from 'utils/constants';
import styled from 'styled-components';

export const PermissionDiv = styled.div`
  margin-bottom:12px;
`;

export const PermissionDetails = styled.div`
  display:inline-block;
  width:70%;
`;

export const PermissionTitle = styled.p`
  margin:2px auto;
  font-weight:bold;
  margin-bottom:0;
`;

export const PermissionMeta = styled.p`
  margin:2px auto;
  font-size:13px;
  color:rgb(200,200,200);
`;

export const PermissionCheckbox = styled(Checkbox)`
  width:15%!Important;
`;

class Preferences extends Component {
  constructor(props) {
    super(props);
    this.state = { user: null, activeIndex: 2 };
  }

  componentDidMount() {
    this.getUser(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) this.getUser(this.props.match.params.id);
  }

  getUser = (id) => {
    this.setState({ loading: true, errorMessage: '' });
    api.users.get(id, (user) => this.setState({ user, loading: false }), (err) => this.setState({ errorMessage: err.message, loading: false }));
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  togglePermission = (scope, permission, enabled) => {
    if (enabled) {
      api.users.addPermission(this.state.user._id, scope, permission, ({ roles }) => {
        const user = { ...this.state.user };
        user.roles = roles;
        this.setState({ user });
      }, (err) => toast.error(err.message));
    } else {
      api.users.removePermission(this.state.user._id, scope, permission, ({ roles }) => {
        const user = { ...this.state.user };
        user.roles = roles;
        this.setState({ user });
      }, (err) => toast.error(err.message));
    }
  };

  render() {
    const { user, t } = this.props;
    const { activeIndex } = this.state;
    const profileUser = this.state.user;
    if (!profileUser) return null;
    return (
      <Container style={{ marginTop: 40 }}>
        <Grid stackable>
          <Grid.Column computer={5}>
            <Segment>
              <Header>{t('users.permissions.title')}</Header>
              {profileUser.profile.fullName ? (
                <p>{t('users.permissions.managePermissions', { user: profileUser.profile.fullName })}</p>
              ) : (
                <p>{t('users.permissions.managePermissions', { user: 'this user' })}</p>
              )}
              <p></p>
              <a target='_blank' rel='noopener noreferrer' href='http://help.simplydo.co.uk/en/articles/2388651-what-are-permissions' style={{ fontSize: 11 }}>
                  <Icon name='question circle' />Find out more about user permissions
                </a>
            </Segment>

            <Segment>
              <Header>{t('users.permissions.info.title')}</Header>
              <p>{t('users.permissions.info.control')}</p>
              <p>{t('users.permissions.info.privileges')}</p>
            </Segment>
          </Grid.Column>

          <Grid.Column computer={11}>
            <Accordion styled>
              {util.isInRole(user, 'super.managePermissions') && (
                <div>
                  <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                    <Icon name="dropdown"/> {t('users.permissions.super.title')}
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 0}>
                    <p>{t('users.permissions.super.info')}</p>
                    {constants.permissions.super.map((permission) => (
                      <PermissionDiv key={permission.key}>
                        <PermissionCheckbox toggle checked={util.isInRole(profileUser, permission.key, '__global_roles__')} onChange={(e, c) => this.togglePermission('__global_roles__', permission.key, c.checked)}/>
                        <PermissionDetails>
                          <PermissionTitle>{permission.title}</PermissionTitle>
                          <PermissionMeta>{permission.text}</PermissionMeta>
                        </PermissionDetails>
                      </PermissionDiv>
                    ))}
                  </Accordion.Content>

                  <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                    <Icon name="dropdown"/> {t('users.permissions.globalOrg.title')}
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <p>{t('users.permissions.globalOrg.info')}</p>
                    {constants.permissions.org.map((permission) => (
                      <PermissionDiv key={permission.key}>
                        <PermissionCheckbox toggle checked={util.isInRole(profileUser, permission.key, '__global_roles__')} onChange={(e, c) => this.togglePermission('__global_roles__', permission.key, c.checked)} />
                        <PermissionDetails>
                          <PermissionTitle>{permission.title}</PermissionTitle>
                          <PermissionMeta>{permission.text}</PermissionMeta>
                        </PermissionDetails>
                      </PermissionDiv>
                    ))}
                  </Accordion.Content>
                </div>
              )}

              {(util.isInRole(user, 'super.managePermissions') || util.isInRole(user, 'org.managePermissions', user.organisation._id)) && (
                <div>
                  <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
                    <Icon name="dropdown"/> {t('users.permissions.currentOrg.title', { user })}
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 2} >
                    <p>{t('users.permissions.currentOrg.info', { user })}</p>
                    {constants.permissions.org.map((permission) => (
                      <PermissionDiv key={permission.key}>
                        <PermissionCheckbox toggle checked={util.isInRole(profileUser, permission.key, user.organisation._id)} onChange={(e, c) => this.togglePermission(user.organisation._id, permission.key, c.checked)} />
                        <PermissionDetails>
                          <PermissionTitle>{permission.title}</PermissionTitle>
                          <PermissionMeta>{permission.text}</PermissionMeta>
                        </PermissionDetails>
                      </PermissionDiv>
                    ))}
                  </Accordion.Content>
                </div>
              )}
            </Accordion>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });

const PreferencesContainer = withRouter(connect(
  mapStateToProps,
)(Preferences));

export default withTranslation()(PreferencesContainer);
